import { getRandomInt } from 'src/model/helpers';

const moment = require('moment');

export function unescapeJson (str) {
    str = str.replaceAll('\r\n', '');
    str = str.replaceAll('\n', '');
    str = str.replaceAll('\t', '');
    // str = str.replaceAll('\\', '');
    return str;
}

export function escapeJsonSave (str) {
    if (!str) {
        return str;
    }
    return str.replace(/[\\]/g, '\\\\')
        // eslint-disable-next-line no-useless-escape
        .replace(/[\"]/g, '\\\"')
        // eslint-disable-next-line no-useless-escape
        .replace(/[\/]/g, '\\/')
        .replace(/[\b]/g, '\\b')
        .replace(/[\f]/g, '\\f')
        .replace(/[\n]/g, '\\n')
        .replace(/[\r]/g, '\\r')
        .replace(/[\t]/g, '\\t');
}

export default function unescapeSql (str) {
    if (!str) {
        return '';
    }
    if (typeof str !== 'string') return str;

    // eslint-disable-next-line no-control-regex,no-useless-escape,consistent-return
    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, (char) => {
        // eslint-disable-next-line default-case
        switch (char) {
            case '\0':
                return '\\0';
            case '\x08':
                return '\\b';
            case '\x09':
                return '\\t';
            case '\x1a':
                return '\\z';
            case '\n':
                return '\\n';
            case '\r':
                return '\\r';
            case '"':
            case "'":
            case '\\':
                // case '%':
                return `\\${char}`;
            case '%':
                return char;
        }
    });
}

export function isEmailValid (email) {
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    return (email === '') ? false : !!(reg.test(email));
}

export function isTelValid (tel) {
    tel = (tel || '').replace(/[^0-9]/g, '');
    return tel.length === 11;
}

export function pureTel (tel) {
    if (!tel) {
        return undefined;
    }
    tel = tel.replace(/[^0-9]/g, '');
    if (tel && tel[0] === '+') {
        tel = tel.slice(1, tel.length);
    }
    if (tel[0] !== '7') {
        tel = `7${tel}`;
    }
    if (tel.length !== 11) {
        return undefined;
    }
    if (tel.length === 11 && tel[0] === '8') {
        tel = tel.slice(1, tel.length);
        tel = `7${tel}`;
    }
    return tel;
}

export function validateTel (tel) {
    if (!tel) {
        return undefined;
    }
    if (tel === '+_ (___) ___-__-__') {
        return undefined;
    }
    if (tel === '+7 (___) ___-__-__') {
        return undefined;
    }
    tel = tel.replace(/[^0-9]/g, '');
    if (tel && tel[0] === '+') {
        tel = tel.slice(1, tel.length);
    }
    if (tel.length !== 11) {
        return false;
    }
    return true;
}

export function getSmsCount (text) {
    const rus = 'ёйцукенгшщзхъфывапролджэячсмитьбю';
    if (!text) {
        return 0;
    }
    let charsCount = 0;
    for (let i = 0; i < text.length; i += 1) {
        const c = text[i];
        if (rus.includes(c.toLowerCase())) {
            charsCount += 2;
        } else {
            charsCount += 1;
        }
    }
    const count = Math.ceil(charsCount / 144);
    return count;
}

export function removeReturns (text) {
    if (!text) {
        return text;
    }
    text = text.replace(/\n/g, '');
    text = text.replace(/\r/g, '');
    text = text.replaceAll(';', ',');
    return text || '';
}

export function getRandomDateTimeFromInterval (date, timeFrom = 8, timeTo = 19) {
    const hh = getRandomInt(timeFrom, timeTo).toString();
    const mm = getRandomInt(0, 59).toString();
    const ss = getRandomInt(0, 59).toString();

    if (date.includes('{')) {
        const dateObject = JSON.parse(date);
        if (dateObject && dateObject.from && dateObject.to) {
            const d1 = moment(dateObject.from);
            const d2 = moment(dateObject.to);
            const daysBetween = d2.diff(d1, 'days');
            const days = getRandomInt(0, daysBetween);
            const d = d1.add(days, 'day').set({ hours: hh, minutes: mm, seconds: ss });
            return d.format('YYYY-MM-DD HH:mm:ss');
        }
    }
    const d = moment(date).set({ hours: hh, minutes: mm, seconds: ss });
    return d.format('YYYY-MM-DD HH:mm:ss');
}

export function removeDuplicatesHashtags (hashtags) {
    const tags = [];
    const arr = hashtags.split(' ');
    arr.every((tag) => {
        if (!tags.includes(tag)) {
            tags.push(tag);
        }
        return true;
    });
    return tags.join(' ').trim();
}

export function escapeCsv (text) {
    if (!text) {
        return undefined;
    }
    text = text || '';
    text = text.replaceAll('&amp;', '&');
    text = text.replaceAll('&laquo;', '«');
    text = text.replaceAll('&raquo;', '»');
    text = text.replaceAll('&#171;', '«');
    text = text.replaceAll('&#187;', '»');
    text = text.replaceAll('&ndash;', '–');
    text = text.replaceAll('&#124;', '|');
    text = text.replaceAll('&amp;', '&');
    text = text.replaceAll('\r\n', ' ');
    text = text.replaceAll('"', '""');
    return `"${text}"`;
}

export function generatePassword (length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let password = '';

    for (let i = 0; i < length; i += 1) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        password += characters.charAt(randomIndex);
    }

    return password;
}

// eslint-disable-next-line class-methods-use-this
export function compareJSON (oldObj, newObj) {
    const oldValues = {};
    const newValues = {};

    const compare = (obj1, obj2, path = '') => {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in obj2) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj1.hasOwnProperty(key)) {
                if (!obj2[key] && !obj2[key]) {
                    // eslint-disable-next-line no-continue
                    continue;
                }
                if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
                    compare(obj1[key], obj2[key], `${path}${key}.`);
                } else if (obj1[key] !== obj2[key]) {
                    oldValues[`${path}${key}`] = obj1[key];
                    newValues[`${path}${key}`] = obj2[key];
                }
            } else {
                newValues[`${path}${key}`] = obj2[key];
            }
        }
    };
    compare(oldObj, newObj);
    return { oldValues, newValues };
}

// eslint-disable-next-line class-methods-use-this
export function parseJson (text, defaultValue = {}) {
    if (!text) {
        return defaultValue;
    }
    try {
        return JSON.parse(text) || defaultValue;
    } catch (e) {
        console.log(e);
    }
    return defaultValue;
}

export function fixCaps (str) {
    if (!str) { return ''; }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/* eslint-disable */
export function createGUIDByNumber (id) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let s = String(id);
        id = `${1 + +s[s.length - 1]}${s.slice(0, s.length - 1)}`;
        s = Number(`0.${id}`);
        const r = s * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/* eslint-enable */
